export const initUserPermissionLoading = ref<boolean>(false)
